import { render } from "./lessonAgeSubjectEchart.vue?vue&type=template&id=70ccc8f0&scoped=true"
import script from "./lessonAgeSubjectEchart.vue?vue&type=script&lang=js"
export * from "./lessonAgeSubjectEchart.vue?vue&type=script&lang=js"

import "./lessonAgeSubjectEchart.vue?vue&type=style&index=0&id=70ccc8f0&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ccc8f0"]])

export default __exports__